import * as types from './types';

const INITIAL_STATE = {
  fetchError: null,
  isFetching: false,
  report: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ITEMSUMMARY_GETREPORT:
      return {
        ...state,
        report: action.payload.data !== '' ? action.payload.data : 'No Data',
      };
    case types.ITEMSUMMARY_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    case types.ITEMSUMMARY_CLEARREPORT:
      return {
        ...state,
        report: '',
      };
    case types.ITEMSUMMARY_FETCHERROR:
      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message: 'An error has occurred. Please try again',
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/itemsummary/state/reducer.js